



























import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { UploadOptData, fileServer, thumbnailServer } from '@/api/common/upload'
import * as api from '@/api/common/attach'
import { newGuid } from '@/configs/functions'
import { imageFormat } from '@/configs/fileTypes'

@Component
export default class hspGallery extends Vue {
  @Prop({ default: false })
  public viewModel!: boolean
  @Prop({ default: 0 })
  public referId!: number
  @Prop({ default: 0 })
  public referType!: number
  @Prop({ default: newGuid() })
  public tempGuid!: string

  public uploadGuid: string = ''
  public opts: UploadOptData = {
    isMulti: true, //是否支持多个附件，以列表展示
    exts: imageFormat, //'.Jpg.Jpeg.Bmp.Png.Gif', //格式限制 .pdf.doc.docx.png.jpg.gif
    refId: this.referId,
    refType: this.referType, // 从后台获取，refType=(byte)EnumHelper.AttachType.对应枚举
    guid: this.tempGuid // newGuid() // 从后台获取，guid=Guid.NewGuid().ToString()
  }
  public fileList: api.AttachInfo[] = []

  public created() {
    if (this.uploadGuid == '') {
      this.uploadGuid = newGuid()
    }
  }
  public mounted() {
    //按需加载, 传refer相关信息
    window.eventBus.$on('demandGallery', (info: any) => {
      let opt = this.opts
      opt.refId = info.referId
      opt.refType = info.referType
      opt.guid = info.tempGuid
      this.getFiles()
    })
    window.eventBus.$on('uploadComplete', (info: any) => {
      if (info.targetId == this.uploadGuid) {
        this.opts = info.opt
        this.getFiles()
      }
    })

    this.$nextTick(() => {
      if ((this.opts.refType > 0 && this.opts.refId > 0) ||
        (this.opts.refType > 0 && this.opts.guid != '')) {
        this.getFiles()
      }
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('uploadComplete')
    window.eventBus.$off('demandGallery')
  }
  //打开上传组件
  public addFile() {
    if (this.uploadGuid == '') {
      this.uploadGuid = newGuid()
    }
    const opt = this.opts
    if (opt.refId == 0 && opt.guid == '') {
      this.$message({
        type: 'warning',
        message: '未设置refId和guid,请检查!'
      })
    } else {
      window.eventBus.$emit('openUploader', {
        targetId: this.uploadGuid,
        opt: this.opts
      })
    }
  }
  public getThumbnail(f: api.AttachInfo) {
    return thumbnailServer(f.Id, f.TempGuid, f.Name)
  }
  public getFileUrl(f: api.AttachInfo) {
    return fileServer(f.Id, f.TempGuid, f.Name)
  }
  public getFiles() {
    var opt = this.opts
    if (
      (opt.refType > 0 && opt.refId > 0) ||
      (opt.refType > 0 && opt.guid != '')
    ) {
      api
        .getList(opt.refId, opt.refType, opt.guid)
        .then((response: { data: any }) => {
          this.fileList = response.data
          // const data: { opts: UploadOptData, files: AttachInfo[] }
          this.$emit('galleryChange', { opts: opt, files: this.fileList })
        })
    }
  }
  public delFile(id: number) {
    this.$confirm(`确定要删除该图片吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        api.remove(id).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getFiles()
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '操作已取消'
        })
      })
  }
}
